import React, { useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import api from '../../services/api';

const SystemSettings = ({ settings }) => {
  const [rows, setRows] = useState(settings);

  const switchStatus = useCallback((setting) => {
    api.system_settings
      .update({ id: setting.id, value: !setting.value })
      .then(() => {
        setRows(row => row.map(s => (s.id === setting.id ? { ...s, value: !setting.value } : s)));
      });
  }, []);

  return (
    <div className="media-table" style={{ minHeight: 'auto' }}>
      <table className="table table-bordered table-hover">
        <thead>
          <tr className="pretty">
            <th>Setting</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          {
            rows.map((setting) => {
              let data = null;

              if (setting.value_type === 'bool') {
                data = (
                  <button onClick={() => switchStatus(setting)} className={`btn btn-xs btn-toggle status-btn ${setting.value ? 'active' : ''}`}>
                    <span className="handle" />
                  </button>
                );
              } else {
                data = (<p>{setting.value}</p>);
              }

              return (
                <tr key={setting.id}>
                  <td>{setting.label}</td>
                  <td className="text-center">
                    {data}
                  </td>
                </tr>
              );
            })
          }
        </tbody>
      </table>
    </div>
  );
};

SystemSettings.propTypes = {
  settings: PropTypes.arrayOf(Object),
};

SystemSettings.defaultProps = {
  settings: [],
};

export default SystemSettings;
